import BillToReceiveReleaseAttachmentList from '@/components/Financial/BillToReceive/ReleaseAttachmentList';
import { useBillToReceiveReleaseDetailContext } from '@/components/Financial/BillToReceive/ReleaseDetailProvider';
import FinancialAttachmentModal from '@/components/Financial/FinancialAttachmentModal';
import { DefaultRouteTabs } from '@/components/_common';
import { useAccountReceivableArchiveCreate } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function BillToReceiveReleasesAttachmentPage({
  route,
}: PageProps) {
  const intl = useIntl();

  const { installmentId, releaseId } = useBillToReceiveReleaseDetailContext();

  const [modalOpen, modalAction] = useDisclosure(false);

  const accountArchiveCreate = useAccountReceivableArchiveCreate();

  async function handleSubmit(files: File[]) {
    try {
      await accountArchiveCreate.mutateAsync({
        accountReceivableId: releaseId,
        files,
      });
    } catch {}
  }

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        permissions={route.permissions}
        route={{ ...route.parent, key: route.key }}
        baseKey={installmentId.toString()}
        basePath={window.location.pathname.replace('/attachments', '')}
        extra={
          <Button type="primary" onClick={modalAction.open}>
            Adicionar anexos
          </Button>
        }
      >
        <p style={{ marginBottom: 24 }}>
          Visualize, cadastre, ou remova os anexos vinculados a sua conta
        </p>

        <BillToReceiveReleaseAttachmentList />
      </DefaultRouteTabs>

      <FinancialAttachmentModal
        onSubmit={handleSubmit}
        open={modalOpen}
        onClose={modalAction.close}
      />
    </>
  );
}
